import styled from "styled-components";

/**
 * Fills the available Content area and prevents the outer container from scrolling.
 * Title, search form, and action buttons remain fixed; only the table body scrolls.
 */
export const PageLayoutContainer = styled.div`
    flex: 1;
    display: flex;
    flex-direction: column;
    min-height: 0;
    overflow: hidden;
`;

export const PageLayoutScrollableContainer = styled(PageLayoutContainer)`
    overflow-x: hidden;
    overflow-y: auto;
`;
